export enum DateTypeClassificationFilter {
    NONE = 0,
    PUBLICATION = 1,
    INSERTION = 2,
    MODIFICATION = 3
}